import ApiService from '@/services/ApiService'

const REPOSITORY_URL = 'reproduccion_animal'

const ReproduccionRepository = {
  listaReproduccion(idFichaGanadera){
    let data = {
      idFichaGanadera
    }
    return ApiService.get(`${REPOSITORY_URL}/lista_reproduccion`,data)
  },

  crearReproduccion(idFichaGanadera,idLoteAnimal,idMetodoReproduccion,idCategoriaReproduccion,cantidadServicio,cantidadPreñez,comentario){
    let data = {
      idFichaGanadera,
      idLoteAnimal,
      idMetodoReproduccion,
      idCategoriaReproduccion,
      cantidadServicio,
      cantidadPreñez,
      comentario
    }
    return ApiService.post(`${REPOSITORY_URL}/crear`, data)
  },

  actualizarReproduccion(idReproduccionAnimal ,idLoteAnimal,idMetodoReproduccion,idCategoriaReproduccion,cantidadServicio,cantidadPreñez,comentario){
    let data = {
      idReproduccionAnimal,
      idLoteAnimal,
      idMetodoReproduccion,
      idCategoriaReproduccion,
      cantidadServicio,
      cantidadPreñez,
      comentario
    }
    return ApiService.post(`${REPOSITORY_URL}/actualizar`, data)
  },

  borrarReproduccion(idReproduccionAnimal){
    let data = {
      idReproduccionAnimal
    }
    return ApiService.post(`${REPOSITORY_URL}/borrar`, data)
  }
}

export default ReproduccionRepository